/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RemoteDomainDto } from '../models/RemoteDomainDto';
import type { RemoteDomainFilterResponseDto } from '../models/RemoteDomainFilterResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RemoteDomainControllerService {

    /**
     * @param healthStatus
     * @param from
     * @param status
     * @param limit
     * @param name
     * @returns RemoteDomainFilterResponseDto OK
     * @throws ApiError
     */
    public static listRemoteDomains(
        healthStatus?: boolean,
        from?: number,
        status?: 'COMPLETED' | 'PENDING' | 'RUNNING',
        limit?: number,
        name?: string,
    ): CancelablePromise<RemoteDomainFilterResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/remote-domains',
            query: {
                'healthStatus': healthStatus,
                'from': from,
                'status': status,
                'limit': limit,
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static updateRemoteDomain(
        requestBody: RemoteDomainDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/remote-domains',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns RemoteDomainDto Created
     * @throws ApiError
     */
    public static createRemoteDomain(
        requestBody: RemoteDomainDto,
    ): CancelablePromise<RemoteDomainDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/remote-domains',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns RemoteDomainDto OK
     * @throws ApiError
     */
    public static getRemoteDomain(
        name: string,
    ): CancelablePromise<RemoteDomainDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/remote-domains/{name}',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns void
     * @throws ApiError
     */
    public static deleteRemoteDomain(
        name: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/remote-domains/{name}',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
